"use client";

import { c as _c } from "react/compiler-runtime";
import { CollectionLockupFragment } from "@opensea/app-kit";
import { graphql, readFragment, useQuery } from "@opensea/graphql";
import { useOnChange } from "@opensea/ui-kit/hooks";
import { useShallow } from "zustand/react/shallow";
import { ConstellationBackground } from "../ConstellationBackground";
import { CONSTELLATION_BACKGROUND_ROOT_ID, useSelectConstellationBackgroundStore } from "../ConstellationBackgroundStore";
const IGNORE_COLLECTIONS = ["75db99053ab444cfa0d8fb55d1f60547" // CLONE X
];
const LIMIT = 10 + IGNORE_COLLECTIONS.length;
const ConstellationBackground_trendingCollectionFragment = graphql(`
    fragment ConstellationBackgroundTrendingCollection on Collection {
      id
      ...CollectionLockup
    }
  `, [CollectionLockupFragment]);
const trendingCollectionsQuery = graphql(`
    query ConstellationBackgroundTrendingCollectionsQuery($limit: Int) {
      trendingCollections(timeframe: ONE_DAY, limit: $limit) {
        items {
          id
          ...ConstellationBackgroundTrendingCollection
        }
      }
    }
  `, [ConstellationBackground_trendingCollectionFragment]);
const OPERATION_CONTEXT = {
  suspense: false
};
export function ConstellationTrendingCollectionsBackground() {
  const $ = _c(11);
  const [open, pushRootBackground, hasBackgroundWithId] = useSelectConstellationBackgroundStore(useShallow(_temp));
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      limit: LIMIT
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = !open;
  let t2;
  if ($[1] !== t1) {
    t2 = {
      query: trendingCollectionsQuery,
      variables: t0,
      context: OPERATION_CONTEXT,
      pause: t1
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      throwOnError: false
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [t4] = useQuery(t2, t3);
  const {
    data: trendingCollectionsData
  } = t4;
  let t5;
  if ($[4] !== trendingCollectionsData?.trendingCollections.items) {
    t5 = trendingCollectionsData?.trendingCollections.items ?? [];
    $[4] = trendingCollectionsData?.trendingCollections.items;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const trendingCollections = t5;
  let t6;
  if ($[6] !== hasBackgroundWithId || $[7] !== pushRootBackground || $[8] !== trendingCollections) {
    t6 = () => {
      if (!hasBackgroundWithId(CONSTELLATION_BACKGROUND_ROOT_ID) && trendingCollections.length > 0) {
        const items = trendingCollections.map(_temp2).filter(_temp3).filter(_temp4).slice(0, LIMIT);
        pushRootBackground({
          items
        });
      }
    };
    $[6] = hasBackgroundWithId;
    $[7] = pushRootBackground;
    $[8] = trendingCollections;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  useOnChange(trendingCollections, t6);
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ConstellationBackground />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}
function _temp4(item_0) {
  return !IGNORE_COLLECTIONS.includes(item_0.id);
}
function _temp3(item) {
  return Boolean(item);
}
function _temp2(collectionKey) {
  const collection = readFragment(ConstellationBackground_trendingCollectionFragment, collectionKey);
  const imageUrl = "imageUrl" in collection ? collection.imageUrl : null;
  if (!imageUrl) {
    return null;
  }
  return {
    id: collection.id,
    imageUrl
  };
}
function _temp(state) {
  return [state.open, state.pushRootBackground, state.hasBackgroundWithId];
}